import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { Typography } from '@chegg-ui/typography';
import { keyDownHandler } from '../shared';
import { SelectionMenuContainer, SelectionMenuItem, getThemeConfig, IconText } from '../styles';

var renderItemIcon = function renderItemIcon(icon, customTheme, size) {
  if (icon) {
    if (customTheme.showBorderItem) {
      return /*#__PURE__*/React.cloneElement(icon, {
        width: 20,
        height: 20
      });
    } else {
      return size === 'lg' ? /*#__PURE__*/React.cloneElement(icon, {
        size: 'small'
      }) : /*#__PURE__*/React.cloneElement(icon, {
        size: 'xsmall'
      });
    }
  }

  return undefined;
};

var SelectionMenu = function SelectionMenu(props) {
  var items = props.items,
      activeItemIndex = props.activeItemIndex,
      onItemClick = props.onItemClick,
      _props$menuDirection = props.menuDirection,
      menuDirection = _props$menuDirection === void 0 ? 'horizontal' : _props$menuDirection,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      theme = props.theme,
      _props$size = props.size,
      size = _props$size === void 0 ? 'xs' : _props$size,
      restProps = _objectWithoutProperties(props, ["items", "activeItemIndex", "onItemClick", "menuDirection", "fullWidth", "theme", "size"]);

  var itemRefs = [];
  var componentTheme = useComponentTheme({
    name: 'SelectioMenu',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(SelectionMenuContainer, _extends({}, restProps, {
    role: "radiogroup",
    menuDirection: menuDirection,
    fullWidth: fullWidth,
    customTheme: componentTheme
  }), items.map(function (item, index, items) {
    itemRefs.push( /*#__PURE__*/React.createRef());
    return /*#__PURE__*/React.createElement(SelectionMenuItem, {
      menuDirection: menuDirection,
      key: index,
      onClick: function onClick() {
        return onItemClick(index);
      },
      role: "radio",
      "aria-checked": index === activeItemIndex,
      tabIndex: !activeItemIndex && index === 0 || index === activeItemIndex ? 0 : -1,
      onKeyDown: keyDownHandler(itemRefs, activeItemIndex || 0),
      ref: itemRefs[index],
      customTheme: componentTheme,
      firstIndex: 0 === index,
      lastIndex: items.length - 1 === index
    }, /*#__PURE__*/React.createElement("span", null, renderItemIcon(item.icon, componentTheme, size), componentTheme.showBorderItem ? item.text : item.icon && item.text ? /*#__PURE__*/React.createElement(IconText, {
      variant: "button",
      variantType: size
    }, item.text) : item.text && /*#__PURE__*/React.createElement(Typography, {
      variant: "button",
      variantType: size
    }, item.text)));
  }));
};

SelectionMenu.displayName = 'SelectionMenu';
export default SelectionMenu;